export const WEIGHTS = [
    { key: '250', label: '250 г', multiplier: 1 },
    { key: '500', label: '500 г', multiplier: 1.85 },
    { key: '1000', label: '1 кг', multiplier: 3.4 },
];
export const GRINDS = [
    { key: 'whole', label: 'У зернах' },
    { key: 'cezve', label: 'Під турку' },
    { key: 'espresso', label: 'Під еспресо' },
    { key: 'filter', label: 'Під фільтр' },
];
export const ROASTS = [
    { key: 'light', label: 'Світле' },
    { key: 'medium', label: 'Середнє' },
    { key: 'dark', label: 'Темне' },
];
export const BREW_METHODS = [
    { key: 'espresso', label: 'Еспресо' },
    { key: 'filter', label: 'Фільтр' },
    { key: 'cezve', label: 'Турка' },
];
export const TASTE_PROFILES = [
    { key: 'acidic', label: 'Кислотний' },
    { key: 'balanced', label: 'Збалансований' },
    { key: 'chocolate', label: 'Шоколадний' },
];
export const DELIVERY_OPTIONS = [
    { key: 'np_branch', label: 'Нова Пошта, відділення', cost: 80 },
    { key: 'np_courier', label: 'Нова Пошта, курʼєр', cost: 110 },
];
// Сума товарів (без доставки), від якої доставка Новою Поштою стає
// безкоштовною — самовивіз безкоштовний завжди, незалежно від порога.
export const FREE_SHIPPING_MIN_TOTAL = 1200;
export const DEFAULT_WEIGHT = '250';
export const DEFAULT_GRIND = 'whole';
export const labelOf = (list, key) => list.find((entry) => entry.key === key)?.label ?? key;
export const PAYMENT_METHODS = [
    { key: 'card', label: 'Plata by mono', description: 'оплата карткою, Apple Pay, Google Pay' },
    { key: 'cod', label: 'Оплата при отриманні' },
];
export const ORDER_STATUSES = [
    { key: 'roasting', label: 'Обсмажується' },
    { key: 'shipping', label: 'В дорозі' },
    { key: 'delivered', label: 'Доставлено' },
    { key: 'cancelled', label: 'Скасовано' },
];
export const SUB_FREQUENCIES = [
    { key: 'weekly', label: 'Щотижня', discount: 0.2, periodDays: 7 },
    { key: 'biweekly', label: 'Кожні 2 тижні', discount: 0.15, periodDays: 14 },
    { key: 'monthly', label: 'Раз на місяць', discount: 0.1, periodDays: 30 },
];
export const ROASTERS_CHOICE_PRICE = 450;
export const SUB_FREE_SHIPPING_MIN_QTY = 2;
export const SUB_SHIPPING_COST = 80;
